import React, { useState, useEffect } from "react";
import { Divider, Image, Descriptions, Tag, QRCode } from "antd";
import { Container } from "react-bootstrap";
import Moment from "react-moment";
import Common from "./includes/Common";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var PaymentReceipt = function PaymentReceipt(_ref) {
  var _ref$transaction = _ref.transaction,
    transaction = _ref$transaction === void 0 ? null : _ref$transaction,
    company = _ref.company;
  return /*#__PURE__*/_jsx(Container, {
    children: transaction && /*#__PURE__*/_jsxs("div", {
      style: {
        textAlign: "center"
      },
      children: [/*#__PURE__*/_jsx(Image, {
        src: Common.businessAccount.logo,
        fallback: "drawables/ss.png",
        width: "180px"
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("h5", {
        children: ["R\xE9\xE7u de caisse N\u1D52", "00" + transaction.id]
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Descriptions, {
        size: "small",
        layout: "vertical",
        bordered: true,
        column: 1,
        items: [{
          key: '1',
          label: /*#__PURE__*/_jsx("div", {
            style: {
              fontWeigth: "bold",
              textAlign: "center"
            },
            children: "Date"
          }),
          children: /*#__PURE__*/_jsx(Moment, {
            format: "DD/MM/YYYY"
          })
        }, {
          key: '2',
          label: /*#__PURE__*/_jsx("div", {
            style: {
              fontWeigth: "bold",
              textAlign: "center"
            },
            children: "Client"
          }),
          children: /*#__PURE__*/_jsx(_Fragment, {
            children: company && /*#__PURE__*/_jsx(Tag, {
              color: "#f50",
              children: company.label
            })
          })
        }, {
          key: '3',
          label: /*#__PURE__*/_jsx("div", {
            style: {
              fontWeigth: "bold",
              textAlign: "center"
            },
            children: "Total commande (GNF)"
          }),
          children: transaction.total_amount.toLocaleString("Fr")
        }, {
          key: '4',
          label: /*#__PURE__*/_jsx("div", {
            style: {
              fontWeigth: "bold",
              textAlign: "center"
            },
            children: "Total pay\xE9 (GNF)"
          }),
          children: transaction.paid_amount.toLocaleString("Fr")
        }, {
          key: '5',
          label: /*#__PURE__*/_jsx("div", {
            style: {
              fontWeigth: "bold",
              textAlign: "center"
            },
            children: "Reste \xE0 payer (GNF)"
          }),
          children: (transaction.total_amount - transaction.paid_amount).toLocaleString("Fr")
        }, {
          key: '6',
          label: /*#__PURE__*/_jsx("div", {
            style: {
              fontWeigth: "bold",
              textAlign: "center"
            },
            children: "Agent"
          }),
          children: Common.currentUser.prenom + " " + Common.currentUser.nom
        }]
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("div", {
        style: {
          textAlign: "center"
        },
        children: transaction && /*#__PURE__*/_jsx(QRCode, {
          type: "svg",
          value: Common.baseUrl + "#/checkreceipt/" + transaction.id.toString()
        })
      })]
    })
  });
};
export default PaymentReceipt;